import httpClient from "@plugins/http";

export default {
  /**
   * Create Question
   * @param {*} requestData
   */
  createSession(requestData) {
    return httpClient.post(`/apis/algebrakit/session/create`, requestData);
  },
  getSessionId(requestData) {
    return httpClient.get(`/apis/algebrakit/get/session-details`, {
      params: requestData,
    });
  },
};
